import { type Action } from 'react-sweet-state';

import { writeRemoteActionsMetasToLocalStorage } from '../../../remote-actions-localstore';
import { type RemoteActionsStoreState } from '../../index';

export const saveActionPerformedAttempt =
	(actionId: string): Action<RemoteActionsStoreState> =>
	({ getState, setState }) => {
		const { meta, product } = getState();
		const currentAttemptCount = meta[actionId]?.attemptCounts || 0;

		const updatedMetas = {
			...meta,
			[actionId]: {
				lastPerformAttemptedAt: Date.now(),
				attemptCounts: currentAttemptCount + 1,
			},
		};

		setState({
			meta: updatedMetas,
		});

		// Can not happen.
		if (!product) {
			throw new Error('Product is not defined.');
		}

		writeRemoteActionsMetasToLocalStorage(product, updatedMetas);
	};
